import log from 'salvo-lite/log'
import { getPrice } from '../helpers/shopify'
import axios from 'axios'

class CartUpdate {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = JSON.parse(elem.getAttribute('data-cart-update'))
        this._action = this._data.action
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._elem.addEventListener(this._data.event_listener, e => {
            e.preventDefault()
            const data = JSON.parse(this._elem.getAttribute('data-cart-update'))
            const variantID = parseInt(data.variant_id)
            this[this._action](variantID)
        })
        // Do not use
        // this.validateCart()
    }

    //
    // this function was built to fix issues with the cart but just caused products to be removed from the cart...
    // and I didn't have time to fix it. Needs remaking.
    //

    // validateCart () {
    //     document.body.classList.remove('fade')
    //     axios.get('/cart.js').then((response) => {
    //         console.log('Hello')
    //         let justHasMethodsLeft = true
    //         let orphans = []
    //         for (let i = 0; i < response.data.items.length; i++) {
    //             const item = response.data.items[i]
    //             if (item.properties) {
    //                 if (item.properties._isTest === true || item.properties._isGiftCard) {
    //                     justHasMethodsLeft = false
    //                 }
    //                 if (item.properties._isTest && !item.properties._isGiftCard) {
    //                     console.log('Is test and not giftcard')
    //                     let id = item.variant_id
    //                     let found = false
    //                     for (let _item of response.data.items) {
    //                         console.log('Hello again ')
    //                         console.log(id)
    //                         console.log(_item.properties._testVariantId)
    //                         if (_item.properties._testVariantId === id && !item.properties._isTest) {
    //                             found = true
    //                         }
    //                     }
    //                     console.log(found)
    //                     if (!found) {
    //                         orphans.push(id)
    //                     }
    //                 }
    //             }
    //         }
    //         console.log('done')
    //         console.log(orphans)
    //         if (justHasMethodsLeft) {
    //             axios.post('/cart/clear.js')
    //         } else if (orphans.length > 0) {
    //             let json = []
    //             for (let orphan of orphans) {
    //                 json.push(`"${orphan}": 0`)
    //             }
    //             let formatted = json.join(',')
    //             let payload = JSON.parse(`{${formatted}}`)
    //             console.log(formatted)
    //             console.log(payload)
    //             axios.post('/cart/update.js', {
    //                 updates: payload
    //             }).then((response) => {
    //                 window.location.reload()
    //             }).catch(function (error) {
    //                 console.error(error)
    //             })
    //         }
    //     })
    // }

    remove (variantID) {
        const itemKey = this._data.itemKey || false
        const self = this
        document.body.classList.add('fade')

        const updateCart = () => {
            document.body.classList.remove('fade')
            axios.get('/cart.js').then((response) => {
                let justHasMethodsLeft = true
                for (let i = 0; i < response.data.items.length; i++) {
                    const item = response.data.items[i]
                    if (item.properties._isTest === true || item.properties._isGiftCard) {
                        justHasMethodsLeft = false
                    }
                }

                if (justHasMethodsLeft) {
                    axios.post('/cart/clear.js')
                }
            })
        }

        axios.get('/cart.js').then((response) => {
            // get batching group id
            // see if there are other tests with that id
            // if so just remove the selected variant
            // if not remove the collection method as well
            console.dir(response.data)
            let batchingGroupID = false
            let moreTestsInBatch = false
            let itemIsGiftCard = false
            for (let i = 0; i < response.data.items.length; i++) {
                const item = response.data.items[i]
                if (item.key === itemKey) {
                    if (item.properties) {
                        if (item.properties._id) {
                            console.log('selected item bundle id: ', item.properties._id)
                            batchingGroupID = item.properties._id
                            self.exponea(item, 'remove')
                        }
                    }
                }
            }
            for (let i = 0; i < response.data.items.length; i++) {
                const item = response.data.items[i]
                if (item.key !== itemKey) {
                    if (item.properties) {
                        if (item.properties._id === batchingGroupID && item.properties._isTest) {
                            console.log('other item in bundle: ', item)
                            moreTestsInBatch = true
                            self.exponea(item, 'remove')
                        }
                    }
                }
            }
            for (let i = 0; i < response.data.items.length; i++) {
                const item = response.data.items[i]
                if (item.variant_id === variantID) {
                    if (item.properties) {
                        if (item.properties._isGiftCard) {
                            itemIsGiftCard = true
                        }
                    }
                }
            }

            axios.post('/cart/update.js', {
                updates: {
                    [variantID]: 0
                }
            }).then((response) => {
                if (moreTestsInBatch || itemIsGiftCard) {
                    self.removeCartItem(variantID)
                    self._updateCartTotal(response.data)
                    setTimeout(function () {
                        self.updateCartCount()
                        axios.get('/cart.js').then((response) => {
                            // if cart is empty, remove cart table
                            if (response.data.item_count === 0) {
                                document.querySelector('.cart-main__items table').remove()
                                document.querySelector('.cart-main__items').innerHTML = '<p class="p-tb-l">There are no items in your basket</p><a href="/" class="chevron-link chevron-link__left sm">Continue shopping</a>'
                            }
                            updateCart()
                        })
                    }, 1000)
                }
            }).catch(function (error) {
                console.error(error)
                updateCart()
            })

            if (!moreTestsInBatch && !itemIsGiftCard) {
                console.log('No more tests in batch, delete collection method')
                for (let i = 0; i < response.data.items.length; i++) {
                    const item = response.data.items[i]
                    if (item.variant_id !== variantID) {
                        if (item.properties._id === batchingGroupID) {
                            console.log('collection method', item)
                            setTimeout(() => {
                                axios.post('/cart/update.js', {
                                    updates: {
                                        [item.key]: 0
                                    }
                                }).then((response) => {
                                    self.removeCartItem(variantID)
                                    self.removeCartItem(item.variant_id)
                                    self._updateCartTotal(response.data)
                                    setTimeout(function () {
                                        self.updateCartCount()
                                        axios.get('/cart.js').then((response) => {
                                            if (response.data.item_count === 0) {
                                                document.querySelector('.cart-main__items table').remove()
                                                document.querySelector('.cart-main__items').innerHTML = '<p class="p-tb-l">There are no items in your basket</p><a href="/" class="chevron-link chevron-link__left sm">Continue shopping</a>'
                                                document.querySelector('[href="/checkout/"]').remove()
                                                document.querySelector('[href="/checkout/"]').remove()
                                            } else {
                                                const batches = []
                                                for (let i = 0; i < response.data.items.length; i++) {
                                                    const item = response.data.items[i]
                                                    if (item.properties._id) {
                                                        if (!batches.includes(item.properties._id)) {
                                                            batches.push(item.properties._id)
                                                        }
                                                    }
                                                }
                                                if (batches.length === 1) {
                                                    const batchesText = document.querySelectorAll('.cart-item .text-left.light')
                                                    for (let i = 0; i < batchesText.length; i++) {
                                                        batchesText[i].remove()
                                                    }
                                                }
                                            }
                                            updateCart()
                                        })
                                    }, 1500)
                                }).catch(function (error) {
                                    console.error(error)
                                    updateCart()
                                })
                            }, 1500)
                        }
                    }
                }
            }
            if (response.data.items.length === 0) {
                location.reload()
            }
        })
    }

    removeCartItem (variantID) {
        if (document.querySelector(`.cart-item[data-variant-id="${variantID}"]`)) {
            document.querySelector(`.cart-item[data-variant-id="${variantID}"]`).remove()
        }
    }
    // test
    updateCartCount () {
        let cartItemCount = 0
        axios.get('/cart.js').then((response) => {
            for (let i = 0; i < response.data.items.length; i++) {
                const item = response.data.items[i]
                if (item.product_type !== 'Clinic' && item.product_type !== 'Collection Method') {
                    cartItemCount += 1
                }
            }
            const cartIcon = document.querySelector('[data-cart-count]')
            if (cartItemCount > 0) {
                if (!cartIcon.classList.contains('has-items')) {
                    cartIcon.classList.add('has-items')
                }
                cartIcon.setAttribute('data-cart-count', cartItemCount)
            } else {
                cartIcon.setAttribute('data-cart-count', '')
                cartIcon.classList.remove('has-items')
            }
        })
    }

    _updateCartTotal (cart) {
        const cartTotalElem = document.querySelector('[data-cart-total]')
        cartTotalElem.textContent = getPrice(cart.total_price)
    }

    exponea (product, action) {
        setTimeout(function () {
            axios.get('/cart.js').then((response) => {
                console.log(response.data)
                const exponeaData = {
                    key: product.key, // key of the item that has been added or removed
                    handle: product.handle, // handle of the item that has been added or removed
                    product_price: product.price / 100, // price in GBP of the item that has been added or removed
                    product_id: product.product_id, // product_id of the item that has been added or removed
                    product_name: product.product_title, // product_title of the item that has been added or removed
                    product_type: product.product_type, // product_type of the item that has been added or removed
                    product_sku: product.sku, // sku of the item that has been added or removed
                    url: product.url, // url of the item that has been added or removed
                    action: action, // "add" or "remove" depending on whether the action was add to cart or remove from cart, also applies to changes of quantities
                    currency: response.data.currency, // currency of the cart, "GBP"
                    item_count: response.data.item_count, // number of items in cart
                    cart_total: response.data.total_price / 100, // total_price of the cart in GBP
                    token: response.data.token, // cart token, generated by shopify, used for cart abandonment scenario (optional)
                    items: response.data.items // JSON list of items
                }
                if (product.discounted_price < product.price) {
                    exponeaData.discounted_price = product.discounted_price / 100 // in GBP of the item that has been added or removed
                    exponeaData.product_original_price = product.original_price / 100 // original_price in GBP of the item that has been added or removed
                }
                window.exponea.track('cart_update', exponeaData)
            })
        }, 2000)
    }
}

export default CartUpdate



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CartUpdate.js